import React from "react";
import { listClients } from "../../web/clients";

export const ClientsSection = ({ className = "mt-16", compact = false }: { className?: string; compact?: boolean }) => {
  const [logos, setLogos] = React.useState<Array<any>>([]);
  React.useEffect(() => { listClients().then((c) => setLogos(c)); }, []);
  return (
    <section className={className} aria-labelledby="clientes-title">
      <h3 id="clientes-title" className="text-xl md:text-2xl font-semibold text-slate-100">Nuestros clientes</h3>
      <p className="text-slate-400 mt-1">Algunas marcas con las que colaboramos.</p>
      <div className={`mt-6 grid ${compact ? 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-6' : 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-6'} gap-4`}>
        {logos.map((c) => (
          <ClientLogo key={c.id} name={c.name} short={c.short} img={c.logo} href={c.href} />
        ))}
      </div>
    </section>
  );
};

export const ClientLogo = ({
  name,
  short,
  img,
  href,
}: {
  name: string;
  short: string;
  img?: string;
  href?: string;
}) => {
  const content = img ? (
    <img
      src={img}
      alt={name}
      className="max-h-12 object-contain grayscale group-hover:grayscale-0 transition"
    />
  ) : (
    <div
      className="text-2xl font-black tracking-wider text-slate-200/80 group-hover:text-indigo-200 transition"
      aria-label={name}
    >
      {short}
    </div>
  );

  return (
    <div className="group relative overflow-hidden rounded-2xl border border-white/10 bg-white/5 px-4 py-6 flex items-center justify-center">
      {href ? (
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-full h-full"
        >
          {content}
        </a>
      ) : (
        content
      )}
      <span className="sr-only">{name}</span>
    </div>
  );
};
